import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";

import { isValid } from "date-fns";
import { ZipRegexp } from "@qqcw/qqsystem-util";

import { QsysProfile, Account } from "src/app/core/services/myqq";
import { zipMask } from "src/app/shared/utilities/ngx-mask-custom";

@Component({
  selector: "myqq-enter-account-details",
  // tslint:disable-next-line:use-component-view-encapsulation
  templateUrl: "./enter-account-details.component.html",
  styleUrls: ["./enter-account-details.component.scss"],
})
export class EnterAccountDetailsComponent implements OnInit {
  constructor(private readonly fb: FormBuilder) {}

  processing = false;

  @Input() account?: Account;
  @Input() profileData?: QsysProfile;
  @Input() zipcode?: string;

  @Output()
  saveProfile = new EventEmitter<Partial<Account>>();

  @Output()
  hasMembership = new EventEmitter();

  @Output()
  restart = new EventEmitter();

  readonly isValid = isValid;
  readonly zipMask = zipMask;

  readonly profileForm = this.fb.group({
    firstName: ["", Validators.required],
    lastName: ["", Validators.required],
    checkbox: ["", Validators.required],
    zipCode: ["", [Validators.required, Validators.pattern(ZipRegexp)]],
  });

  ngOnInit() {
    if (this.profileData && this.profileData.name) {
      const [firstName, ...latterNames] = this.profileData.name.split(" ");
      this.profileForm.patchValue({
        firstName,
        lastName: latterNames.join(" "),
      });
    }
    if (this.zipcode) {
      this.profileForm.patchValue({
        zipCode: this.zipcode,
      });
    }

    if (this.account) {
      this.profileForm.patchValue(this.account);
    }
  }

  async confirm() {
    if (!this.profileForm.valid) {
      return;
    }

    this.processing = true;

    this.saveProfile.emit({
      ...this.profileForm.value,
    });
  }

  async cancel() {
    this.restart.emit();
  }
}
